import { useNavigate } from 'react-router';
import { useToast } from '../lib/use-toast';
import { logout } from './auth.api';
import { useCurrentUser } from './CurrentUserProvider';

/** Ends the session and returns to login. A failed logout call still clears the local user — the cookie expires on its own. */
export function useSignOut(): () => Promise<void> {
  const navigate = useNavigate();
  const { clearUser } = useCurrentUser();
  const toast = useToast();

  return async () => {
    await logout().catch(() => undefined);
    clearUser();
    navigate('/login', { replace: true });
    toast.success('Signed out');
  };
}
